
<ng-container *ngIf="!isMultiSelect else multiSelect">
  <p-floatlabel class="w-full md:w-56" variant="on">
    <p-select
      [options]="options"
      [formControl]="options.length > 0 ? valueFormControl : emptyFormControl"
      [filter]="true"
      [emptyFilterMessage]="'primeng.noResultFound' | translate"
      [emptyMessage]="'primeng.noResultFound' | translate"
      [showClear]="true"
      (onChange)="handleSelectionChange($event)"
      [optionValue]="'value'"
      optionLabel="label"
      appendTo="body"
      [virtualScroll]="true"
      [virtualScrollItemSize]="38"
      [lazy]="true"
    >
      <ng-template pTemplate="empty">
        <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
      </ng-template>
    </p-select>
    <label [addAsteriskIfRequired]="valueFormControl">{{fieldPlaceholder}}</label>
  </p-floatlabel>
</ng-container>

<ng-template #multiSelect>
  <p-floatlabel class="w-full md:w-56" variant="on">
    <p-multiSelect
      [options]="options"
      [formControl]="options.length > 0 ? valueFormControl : emptyFormControl"
      [filter]="true"
      [emptyFilterMessage]="'primeng.noResultFound' | translate"
      [emptyMessage]="'primeng.noResultFound' | translate"
      [selectedItemsLabel]="'primeng.selectedItemsLabel' | translate"
      [showClear]="true"
      (onChange)="handleSelectionChange($event)"
      [optionValue]="'value'"
      optionLabel="label"
      [showToggleAll]="showToggleAll"
      appendTo="body"
      [virtualScroll]="true"
      [virtualScrollItemSize]="38"
      [lazy]="true"
    >
      <ng-template pTemplate="empty">
        <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
      </ng-template>
    </p-multiSelect>
    <label [addAsteriskIfRequired]="valueFormControl">{{fieldPlaceholder}}</label>
  </p-floatlabel>

</ng-template>

<ng-template #emptyTemplate>
    <p class="empty-message">
        <ng-container *ngIf="loading else emptyMessage">
            {{'primeng.loading' | translate}}
        </ng-container>
        <ng-template #emptyMessage>
            {{'primeng.noResultFound' | translate}}
        </ng-template>
    </p>
</ng-template>
